module.exports = __webpack_public_path__ + "img/report-active.c95e9288.svg";